import I18n from 'main/theme/i18n';

/**
 * @function
 * @description Returns the internationalization method
 * Used to encapsulate logic and do not cause failures during SSR
 * @returns
 */
export default function useI18n() {
    return I18n.get;
}
